import '../assets/NcAssistantIcon-BFNU0uqH.css';
import { useCssVars, computed } from "vue";
import { e as mdiCreation } from "./mdi-DXu6GWVJ.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const assistantIcon = "_assistantIcon_1ndue_20";
const assistantIcon_inline = "_assistantIcon_inline_1ndue_25";
const assistantIcon__svg = "_assistantIcon__svg_1ndue_30";
const style0 = {
  "material-design-icon": "_material-design-icon_1ndue_12",
  assistantIcon,
  assistantIcon_inline,
  assistantIcon__svg
};
const _sfc_main = {
  __name: "NcAssistantIcon",
  props: {
    /**
     * Set if the icon should be used as inline content e.g. within text.
     * By default the icon is made a block element for use inside `icon`-slots.
     */
    inline: {
      type: Boolean,
      default: false
    },
    /**
     * Size of the icon.
     * Defaults to the proper size to be used in buttons and other interactive elements
     * like all `Nc*` components with an icon slot.
     */
    size: {
      type: Number,
      default: 20
    }
  },
  setup(__props) {
    const props = __props;
    useCssVars((_vm, _setup) => ({
      "458a86db": _setup.sizePx
    }));
    const sizePx = computed(() => `${props.size}px`);
    return { __sfc: true, props, sizePx, mdiCreation };
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("span", { class: [_vm.$style.assistantIcon, _vm.inline && _vm.$style.assistantIcon_inline], attrs: { "aria-hidden": "true", "role": "img" } }, [_c("svg", { class: _vm.$style.assistantIcon__svg, attrs: { "viewBox": "0 0 24 24", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("defs", [_c("linearGradient", { attrs: { "id": "AssistantGradient", "gradientTransform": "rotateX(285)" } }, [_c("stop", { attrs: { "offset": "15%", "stop-color": "#9669D3" } }), _c("stop", { attrs: { "offset": "40%", "stop-color": "#00679E" } }), _c("stop", { attrs: { "offset": "80%", "stop-color": "#492083" } })], 1)], 1), _c("path", { attrs: { "d": _setup.mdiCreation, "fill": "url('#AssistantGradient')" } })])]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcAssistantIcon = __component__.exports;
export {
  NcAssistantIcon as N
};
//# sourceMappingURL=NcAssistantIcon-tjSguP9N.mjs.map
